module.exports = __webpack_public_path__ + "static/media/enggun.36399c8e.svg";